import { Box, Grid } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { useMerchantPaymentsData } from "../hooks/useMerchantPaymentsData"
import { CreditCardContentBasedOnStatusAndDetails } from "../../../../../supplier/admin/merchant/merchants/components/CreditCardContentBasedOnStatusAndDetails"

const useStyles = makeStyles()(() => ({
    content: {
        gap: "2rem",
    },
    boxTitleWrap: {
        display: "flex",
        alignItems: "center",
        gap: "1.25rem",
    },
}))

export function CreditCardsPaymentAside() {
    const { classes } = useStyles()

    const { acquiringDetails, bankAccountDetails, isBankAccount, status, isLoading } = useMerchantPaymentsData()

    return (
        <Grid container direction="column" wrap="nowrap" className={classes.content}>
            <Box className={classes.boxTitleWrap}>
                <Grid container flexDirection="column" alignItems="start" gap={3}>
                    <CreditCardContentBasedOnStatusAndDetails
                        isLoading={isLoading}
                        readonly
                        status={status}
                        acquiringDetails={acquiringDetails}
                        bankAccountDetails={bankAccountDetails}
                        isBankAccount={isBankAccount}
                        handleClick={() => {}}
                    />
                </Grid>
            </Box>
        </Grid>
    )
}
